import React from 'react';
import { Button } from 'antd';
import { Icon } from '@common/components';

export const NumericRangeFilterButton = ({
  keyName,
  unit,
  rangeArray,
  clearFilter,
}: {
  keyName: string;
  unit: string | null;
  rangeArray: [number, number];
  clearFilter: (value: string) => void;
}) => (
  <Button onClick={() => clearFilter(keyName)}>
    <Icon icon="xMark" kind="light" />
    {`${rangeArray[0]} - ${rangeArray[1]}`}
    {unit && ` ${unit}`}
  </Button>
);
